import { render, staticRenderFns } from "./ReasonTaskModal.vue?vue&type=template&id=6630d252&scoped=true"
import script from "./ReasonTaskModal.vue?vue&type=script&lang=js"
export * from "./ReasonTaskModal.vue?vue&type=script&lang=js"
import style0 from "./ReasonTaskModal.vue?vue&type=style&index=0&id=6630d252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630d252",
  null
  
)

export default component.exports